import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { showAlert } from 'utility/SweetAlert'

const InteractorProductPriceListUpdateBatch = () => {
  const priceListUpdateBatch = useCallback((body, loading) => {
    let payload = {
      ...body,
    }
    if (body.isArray) {
      payload = [...body.data]
    }
    const isAlert = body.alert ?? false
    ApiService.jsonRequest('/product/price-list/update-batch', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        if (isAlert) {
          showAlert({
            icon: 'success',
            message:
              payload.is_deleted === 'Y'
                ? getTranslate('message.successfully_deleted')
                : getTranslate('message.successfully_updated'),
            timer: 2000,
            redirect: '/product/schema/manage',
          })
        }
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
    })
  }, [])
  return { priceListUpdateBatch }
}

export default InteractorProductPriceListUpdateBatch
